import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../../app/services/aha-api";
const initialState = {
  value: [],
  status: false,
  loading: false,
};

export const postConfirmLostDevice = createAsyncThunk(
  "account/postConfirmLostDevice",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.confirmLostDevice(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const confirmLostDeviceSlice = createSlice({
  name: "confirmLostDevice",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(postConfirmLostDevice.pending, (state) => {
        state.loading = true;
      })
      .addCase(postConfirmLostDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(postConfirmLostDevice.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const confirmLostDeviceList = (state) =>
  state && state.confirmLostDevice && state.confirmLostDevice.value;
export const loading = (state) =>
  state && state.confirmLostDevice && state.confirmLostDevice.loading;

export default confirmLostDeviceSlice.reducer;
